import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Form, Button, Breadcrumb, message, Input, Select, Card, Tabs } from "antd";
import { MinusCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import {
  CreateQuizConfig,
  GetQuizByIdConfig,
  UpdateQuizConfig,
} from "src/service/api";
import { adminHomeBcmb } from "src/static/data/breadcrumb_items";
import { QuizTypes, QuizVariantTypes } from "src/static/interface";
import { rules } from "src/static/rules";
import { quizTypeData } from "src/static/data";
import ThemFormItem from "src/components/form_item/theme";

interface VariantFormType {
  textUz: string;
  textRu: string;
  textKk: string;
  textEn: string;
}

function QuizActionsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { TextArea } = Input;
  const { Option } = Select;
  const quizId = searchParams.get("quizId");
  const themeId = searchParams.get("themeId");


  console.log(themeId);

  const getFunc = () => {
    if (quizId) {
      GetQuizByIdConfig(quizId).then((res) => {
        const { data } = res;
        const variantsData = data.variants ? [...data.variants] : [];
        
        variantsData.sort((a: any, b: any) => (a.orderNo || 0) - (b.orderNo || 0));
        let variant1 = variantsData.length > 0 ? variantsData.shift() : null;
        
        const variant1Form = variant1 ? {
          textUz: variant1.textUz || "",
          textRu: variant1.textRu || "",
          textKk: variant1.textKk || "",
          textEn: variant1.textEn || "",
        } : null;
        
        const variantsForm = variantsData.map((v: any) => ({
          textUz: v.textUz || "",
          textRu: v.textRu || "",
          textKk: v.textKk || "",
          textEn: v.textEn || "",
        }));
        
        form.setFieldsValue({
          quizUz: data.quizUz || "",
          quizRu: data.quizRu || "",
          quizKk: data.quizKk || "",
          quizEn: data.quizEn || "",
          variant1: variant1Form,
          variants: variantsForm,
          themeId: data.themeId,
          buttonType: data.buttonType,
          photoUrl: data.photoUrl || "",
        });
      });
    }
  };

  useEffect(() => {
    getFunc();
  }, []);

  const handleSubmit = (val: any) => {
    let { variant1, variants: formVariants, ...rest } = val;
    
    let variants: QuizVariantTypes[] = [];
    
    if (variant1 && (variant1.textUz || variant1.textRu || variant1.textKk || variant1.textEn)) {
      variants.push({
        textUz: variant1.textUz || "",
        textRu: variant1.textRu || "",
        textKk: variant1.textKk || "",
        textEn: variant1.textEn || "",
        orderNo: 0,
      });
    }
    
    if (formVariants && formVariants.length > 0) {
      formVariants.forEach((v: VariantFormType, index: number) => {
        if (v && (v.textUz || v.textRu || v.textKk || v.textEn)) {
          variants.push({
            textUz: v.textUz || "",
            textRu: v.textRu || "",
            textKk: v.textKk || "",
            textEn: v.textEn || "",
            orderNo: index + 1,
          });
        }
      });
    }




    const payload: QuizTypes = {
      ...rest,
      variants,
    };


    setLoading(true);
    if (payload.quizUz && payload.quizRu && payload.quizKk && payload.quizEn) {
      if (quizId) {
        UpdateQuizConfig(quizId, payload)
          .then(() => {
            message.success("So'rovnoma muvaffiyaqatli tahrirlandi");
            navigate(themeId ? `/admin/quiz?themeId=${themeId}` : "/admin/quiz");
          })
          .finally(() => setLoading(false));
      } else {
        CreateQuizConfig(payload)
          .then(() => {
            message.success("So'rovnoma muvaffiyaqatli qo'shildi");
            navigate(themeId ? `/admin/quiz?themeId=${themeId}` : "/admin/quiz");
          })
          .finally(() => setLoading(false));
      }
    } else {
      message.error("So'rovnoma savolini va variantlarini to'liq kiriting");
      setLoading(false);
    }

    
  };

  const handleChange = (val: string) => {
    if (val === "input") {
      form.setFieldsValue({ variant1: null, variants: null });
    }
  };

  const languages = [
    { key: "uz", label: "O'zbekcha", suffix: "Uz" },
    { key: "ru", label: "Русский", suffix: "Ru" },
    { key: "kk", label: "Qaraqalpaqsha", suffix: "Kk" },
    { key: "en", label: "English", suffix: "En" },
  ];

  // Tab label with error indicator
  const TabLabelWithError = ({ label, hasError }: { label: string; hasError: boolean }) => (
    <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
      {label}
      {hasError && (
        <ExclamationCircleOutlined style={{ color: "#ff4d4f", fontSize: 14 }} />
      )}
    </span>
  );

  return (
    <div>
      <Breadcrumb
        items={[
          adminHomeBcmb,
          {
            title: (
              <div style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
                So'rovnomalar
              </div>
            ),
          },
          {
            title: quizId ? "So'rovnomani tahrirlash" : "So'rovnoma qo'shish",
          },
        ]}
      />
      <div className="layout-detail">
        <div className="layout-detail-header">
          {quizId
            ? "So'rovnoma ma'lumotlarini tahrirlash"
            : "So'rovnoma qo'shish"}
        </div>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <ThemFormItem />
          <Form.Item
            name="buttonType"
            label="So'rovnoma turi"
            rules={[rules.block_s]}
          >
            <Select
              allowClear
              size="large"
              placeholder={rules.block_s.message}
              onChange={handleChange}
            >
              {quizTypeData.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="photoUrl" label="Rasm URL (ixtiyoriy)">
            <Input placeholder="https://example.com/image.png" size="large" />
          </Form.Item>

          {/* Language Tabs with Form Fields */}
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue, getFieldError }) => {
              const buttonType = getFieldValue("buttonType");
              const isDisabled = buttonType === "input" || !buttonType;
              const variants = getFieldValue("variants") || [];

              // Check errors for each language
              const getLanguageErrors = (suffix: string) => {
                const quizError = getFieldError(`quiz${suffix}`).length > 0;
                const variant1Error = getFieldError(["variant1", `text${suffix}`]).length > 0;
                const variantErrors = variants.some((_: any, idx: number) => 
                  getFieldError(["variants", idx, `text${suffix}`]).length > 0
                );
                return quizError || (!isDisabled && (variant1Error || variantErrors));
              };

              return (
                <Card style={{ marginBottom: 24 }}>
                  <Tabs
                    defaultActiveKey="uz"
                    type="card"
                    items={languages.map((lang) => ({
                      key: lang.key,
                      label: <TabLabelWithError label={lang.label} hasError={getLanguageErrors(lang.suffix)} />,
                      children: (
                        <div style={{ padding: "16px 0" }}>
                          {/* Quiz Question */}
                          <Form.Item
                            name={`quiz${lang.suffix}`}
                            label={`So'rovnoma savoli (${lang.label})`}
                            rules={[{ required: true, message: `Savolni ${lang.label} tilida kiriting` }]}
                          >
                            <TextArea
                              rows={3}
                              placeholder={`Savolni ${lang.label} tilida kiriting`}
                            />
                          </Form.Item>

                          {/* First Variant */}
                          <Card
                            title={`1-variant (${lang.label})`}
                            size="small"
                            style={{ marginBottom: 16 }}
                            className={isDisabled ? "disabled-card" : ""}
                          >
                            <Form.Item
                              name={["variant1", `text${lang.suffix}`]}
                              rules={isDisabled ? [] : [{ required: true, message: `Variant matnini ${lang.label} tilida kiriting` }]}
                              style={{ marginBottom: 0 }}
                            >
                              <TextArea
                                rows={2}
                                placeholder={`Variant matnini ${lang.label} tilida kiriting`}
                                disabled={isDisabled}
                              />
                            </Form.Item>
                          </Card>

                          {/* Additional Variants */}
                          <Form.List name="variants">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map((field, index) => (
                                  <Card
                                    key={field.key}
                                    title={
                                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <span>{index + 2}-variant ({lang.label})</span>
                                        <MinusCircleOutlined
                                          onClick={() => remove(field.name)}
                                          style={{ color: "#ff4d4f", fontSize: 16 }}
                                        />
                                      </div>
                                    }
                                    size="small"
                                    style={{ marginBottom: 16 }}
                                    className={isDisabled ? "disabled-card" : ""}
                                  >
                                    <Form.Item
                                      name={[field.name, `text${lang.suffix}`]}
                                      rules={isDisabled ? [] : [{ required: true, message: `Variant matnini ${lang.label} tilida kiriting` }]}
                                      style={{ marginBottom: 0 }}
                                    >
                                      <TextArea
                                        rows={2}
                                        placeholder={`Variant matnini ${lang.label} tilida kiriting`}
                                        disabled={isDisabled}
                                      />
                                    </Form.Item>
                                  </Card>
                                ))}
                                <Button
                                  icon={<PlusOutlined />}
                                  type="dashed"
                                  onClick={() => add()}
                                  disabled={isDisabled}
                                  block
                                >
                                  Variant qo'shish
                                </Button>
                              </>
                            )}
                          </Form.List>
                        </div>
                      ),
                    }))}
                  />
                </Card>
              );
            }}
          </Form.Item>

          <div className="modal-footer">
            <Button htmlType="submit" type="primary" loading={loading}>
              Saqlash
            </Button>
          </div>
        </Form>
      </div>

      <style>{`
        .disabled-card {
          opacity: 0.6;
          pointer-events: none;
        }
        .ant-tabs-tab-btn span {
          display: flex;
          align-items: center;
        }
      `}</style>
    </div>
  );
}

export default QuizActionsPage;
